import React, { Fragment } from 'react';
import Vimeo from '@u-wave/react-vimeo';

class HeroLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            volume:0
        }
        this.handleSound = this.handleSound.bind(this)
        this.setHeaderTheme.bind(this);
    }
    componentDidMount() {}

    setHeaderTheme(clr){
        let header = document.querySelector('header');
        let title = document.querySelector('.title-xl');
        if(header){
            header.classList.add(clr);
        }
        if(title){
            title.style.color = clr == 'white' ? '#fff' : '#676769';
        }
    }

    handleSound(param){
        let {volume} = this.state;
        
        if(param == 0){
            this.setState((prev) => ({
                ...prev,
                volume: 0
            }))
        }else{
            this.setState((prev) => ({
                ...prev,
                volume:volume == 0 ? 1 : 0
            }))
        }
        
    }

    render() {
        let {details} = this.props;
        let _this = this;
        let {volume} = this.state;
        let handleClickBelow = this.props.handleClickBelow;
        let clr = this.props.white ? 'white' : '';
        let clr_obj = this.props.white ? {} : {'color':'#676769'};
        let media = `<img class="fullScreen" src="${details.hero_image.url}" alt="${details.post_title}" title="${details.post_title}"  />`;
        console.log(volume)
        if(details.theme == 2){
            this.setHeaderTheme('grey');
            media = `<img class="fullScreen" src="${details.hero_image.url}" alt="${details.hero_image.alt}" title="${details.hero_image.title}" />`
        }else{
            this.setHeaderTheme('white');
            if(details.video){
                switch (Number(details.video.platform)) {
                    case 2:
                        media = `<iframe src="https://www.youtube.com/embed/${details.video.video_id}?mute=1&amp;autoplay=1&amp;rel=0&amp;controls=0&amp;showinfo=0&amp;modestbranding=1&amp;autohide=1" allow="autoplay; encrypted-media"></iframe>`;
                        // version=3&autoplay=1&controls=0&showinfo=0&loop=1&modestbranding=1&autohide=1"
                        break;
                    default:
                        media = `<iframe src="https://www.youtube.com/embed/${details.video.video_id}?mute=1&amp;autoplay=1&amp;rel=0&amp;controls=0&amp;showinfo=0&amp;modestbranding=1&amp;autohide=1" allow="autoplay; encrypted-media"></iframe>`;
                        break;
                }
            }
        }
        return (
			<section data-hammenu={clr}>
                <div className="ll__inner--hero">
                    {
                        details.video && details.video.platform == 1 &&
                        <Fragment>
                            <Vimeo
                                className='video-wrapper'
                                video={details.video.video_id}
                                background={true}
                                volume={volume}
                                muted
                                autoplay
                                autopause={false}
                                loop={true}
                            />
                            

                            <div className="fig-actions">
                                <div className="main-container">
                                    <div className="inner-container text-right">
                                        <a href="javascript:void(0)" className={`toggle-sound sound-${volume === 0 ? 'on' : 'off'}`} onClick={_this.handleSound}></a>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                        
                    }
                    {
                        details.video == null &&
                        <figure dangerouslySetInnerHTML={{__html:media}} />
                    }
                    <div className="bottom-content">
                        <div className="main-container">
                            <h1 className="title-xl" style={clr_obj}>{details.post_title}</h1>
                        </div>
                    </div>
                    <a href="javascript:" id="btn--scroll-down" onClick={handleClickBelow}></a>
                </div>
            </section>
        );
    }
}

export default HeroLayout;


// WEBPACK FOOTER //
// ./src/components/Projects/Details/HeroLayout.js